import gql from "graphql-tag";
import { OFFERS_FRAGMENT } from "../offer/fragment";
import { USER_FRAGMENT } from "../user/fragment";

export const COMPANY_FRAGMENT = gql`
  fragment CompanyInfo on Company {
    id
    address
    city
    code
    countryIsoCode
    countryTaxResidenceIsoCode
    email
    existingCompany
    isAutocomplete
    isIndividual
    legalAddress
    legalCity
    legalCountryIsoCode
    legalFormId
    legalPostcode
    leiCode
    name
    postcode
    registrationDate
    step
    taxpayerIdentificationNumber
    limited
    createCardPhysical
    createCardVirtual
    clientId
  }
`;

export const MY_COMPANY_FRAGMENT = gql`
  fragment MyCompany on MyCompany {
    offer {
      ...OffersInfo
    }
    company {
      ...CompanyInfo
    }
    legalRepresentative {
      ...UserInfo
    }
    users {
      ...UserInfo
    }
    connected {
      ...UserInfo
    }
  }
  ${OFFERS_FRAGMENT}
  ${COMPANY_FRAGMENT}
  ${USER_FRAGMENT}
`;
